<template>
    <v-btn
        color="white"
        x-large
        class="mr-4"
        @click="$emit('click')"
    >
        <v-img width="24" :src="img" />
        <div class="h4 text-capitalize ml-2">{{ $t(name) }}</div>
    </v-btn>
</template>

<script>
import { $t } from "@/i18n";

export default {
    name: "IntegrationButton",
    props: {
        img: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    }
};
</script>
